import { getOffset } from 'common/utils/boxPosition';

export function scrollToElement(element: Element, offsetTop = 0, duration = 500) {
    $('html, body').animate(
        {
            scrollTop: getOffset(element).top - offsetTop,
        },
        duration
    );
}

export function scrollDownToElement(element: Element, offsetTop = 0, duration = 500) {
    if (isElementAboveDocumentScrollTop(element, offsetTop)) {
        scrollToElement(element, offsetTop, duration);
    }
}

function isElementAboveDocumentScrollTop(element: Element, offsetTop: number) {
    const documentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    return getOffset(element).top - offsetTop - documentScrollTop >= 0;
}



// WEBPACK FOOTER //
// ./js/common/utils/scroll.ts